<template>
  <public-page>
    <router-view></router-view>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'

export default {
  name: 'page-template',
  components: {
    PublicPage,
  },
}
</script>

<style lang="scss">
</style>
